<template>
  <div class="wt2-dashboard-produced wt2-breakpoints">
    <div class="-panel">
      <div class="-control-group">
        <div class="wt2-text-2xl">
          {{ 'dashboardProduced.title' | culture }}
        </div>
        <div class="-control">
          <wt-search
            :value="this.$store.getters.videosFilters.q"
            @input="searchQuery"
          />
        </div>
      </div>
      <div class="-control-group">
        <div class="-control">
          <wt-dropdown
            type="normal right"
            :items="types"
            :on-click-item="setVideosType"
            :current-item-id="this.$store.getters.videosFilters.type"
            class="wt2-programmers-dropdown align-self-center"
          />
        </div>
        <div v-if="showBrandsList" class="-control -control-programmers">
          <wt-dropdown
            type="normal right"
            :items="brandsList"
            :on-click-item="setBrand"
            :current-item-id="currentBrandMixedId"
            class="wt2-programmers-dropdown align-self-center"
          />
        </div>
        <div class="-control">
          <wt-toggle
            :label-left="'dashboardProduced.myWork' | culture"
            v-model="$store.state.dashboard.myWork.videos"
            :disabled="isFetching"
            @toggle="refreshCurrentList"
          />
        </div>
      </div>
    </div>

    <wt-continuous-pagination
      v-if="!isEmpty"
      class="-content"
      :on-next-page="onNextPage"
    >
      <ul class="wt2-story-previews list-inline">
        <li
          is="video-preview-item"
          v-for="video in videos"
          tab="Produced"
          :key="video.id"
          :story="video"
        ></li>
      </ul>
    </wt-continuous-pagination>

    <div class="-empty-state-box" v-if="isEmpty">
      <div v-if="hasDefaultVideosFilters" class="-centered">
        <img src="/resources/img/empty_no_produced_videos.png" />
        <div class="-title">{{ 'dashboardProduced.empty1' | culture }}</div>
        <div class="-message">{{ 'dashboardProduced.empty2' | culture }}</div>
      </div>
      <div v-else class="-centered">
        <img src="/resources/img/empty_no_results.png" />
        <div class="-title">
          {{ 'dashboardProduced.emptySearch1' | culture }}
        </div>
        <div class="-message">
          {{ 'dashboardProduced.emptySearch2' | culture }}
        </div>
      </div>
    </div>

    <div class="wt-dashboard-loader" v-show="isFetching">
      <div class="wt-loader"></div>
    </div>
  </div>
</template>

<script>
import app from 'app';
import VideoPreviewItem from 'v/Dashboard/VideoPreviewItem.vue';
import Analytics from 'c/WtAnalytics';
import { mapGetters } from 'vuex';

export default {
  components: {
    VideoPreviewItem,
  },

  data() {
    return {
      types: [
        { id: 'ALL', label: 'All types' },
        { id: 'VO', label: 'Voice over' },
        { id: 'NOVO', label: 'Without voice over' },
      ],
    };
  },

  created() {
    this.$store.getters.videosFilters.q = '';
    this.refreshCurrentList({ bReset: false });
  },

  watch: {
    '$store.state.dashboard.myWork.videos': function (myWorkState) {
      this.$emit('filterschange', {
        filter: myWorkState ? 'My Work On' : 'My Work Off',
      });
    },
  },

  computed: {
    ...mapGetters(['videos', 'hasDefaultVideosFilters']),
    ...mapGetters('user', ['selectedOrganization']),

    isFetching() {
      return this.$store.getters.fetching.videos;
    },

    isEmpty() {
      return this.$store.state.dashboard.hasEmpty.videos && !this.isFetching;
    },

    showBrandsList() {
      return this.selectedOrganizationBrands.length > 1;
    },

    selectedOrganizationBrands() {
      return this.selectedOrganization.brands.map((brand) => ({
        id: brand._mixedId,
        label: brand.name,
      }));
    },

    brandsList() {
      return [
        {
          id: null,
          label: app.culture.dashboardFilter.allBrands,
        },
        ...this.selectedOrganizationBrands,
      ];
    },

    currentBrandMixedId() {
      const { brandId, programmerId } = this.$store.getters.storiesFilters;
      return (
        this.selectedOrganization.brands.find(
          (brand) =>
            brand.brandId === brandId && brand.programmerId === programmerId
        )?._mixedId || null
      );
    },
  },

  methods: {
    refreshCurrentList(options) {
      return this.$store.dispatch('fetchVideos', options);
    },

    setVideosType(type) {
      this.$store.getters.videosFilters.type = type;
      this.refreshCurrentList();
      this.$emit('filterschange', { filter: `Type: ${type}` });
    },

    setBrand(mixedId) {
      const brand = this.selectedOrganization.brands.find(
        (brand) => brand._mixedId === mixedId
      );
      this.$store.getters.videosFilters.brandId = brand?.brandId || null;
      this.$store.getters.videosFilters.programmerId =
        brand?.programmerId || null;
      this.refreshCurrentList();
      this.$emit('filterschange', { filter: 'Production Line' });
    },

    searchQuery(str) {
      Analytics.trigger('analytics:dashboard:search', 'Dashboard Produced');
      this.$store.getters.videosFilters.q = str;
      this.refreshCurrentList();
    },

    onNextPage() {
      this.refreshCurrentList({ bReset: false, bFetchMore: true });
    },
  },
};
</script>
